var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('all-locations-section',{staticClass:"all-itsu-locations-section-module",attrs:{"title":_vm.attributes.allItsuLocations_title,"areas":_vm.attributes.asyncData.areas}})}
var staticRenderFns = []

export { render, staticRenderFns }